import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import axios from "axios";
import { io } from 'socket.io-client';
import './livecounts.css';

const port = process.env.REACT_APP_SERVER_PORT;

function VenueWiseCounts() {
  const [data, setData] = useState({
    xAxis: [{ scaleType: "band", data: [] }],
    series: [{ data: [] }],
  });

  const [isLoading, setIsLoading] = useState(true); // State to handle loading

  const formatXAxisLabels = (labels) => {
    return labels.map(label => {
      if (!label || typeof label !== "string") return "";
      
      let cleanLabel = label.replace(/,\s*Seminar\s+Hall/i, "")
                            .replace(/Seminar\s+Hall/i, "")
                            .trim();
      
      if (cleanLabel.toLowerCase() === "school of business") {
        return "SOB";
      }
      
      const words = cleanLabel.split(/[^a-zA-Z0-9]+/)
                               .filter(word => word.length > 0 && word.toLowerCase() !== "of");
      
      return words.map(word => word.charAt(0).toUpperCase()).join('');
    });
  };

  const baseUrl = "https://adityauniversity.in/blooddonationbackend"
  

  // Fetch data function
  //Department=YES&
  const fetchData = () => {
    axios
      .get(`${port}count-by-venue?EventDate=YES`)
      .then((res) => {
        console.log("DATA", res.data);
        setData(res.data);
        setIsLoading(false); // Set loading to false once data is fetched
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setIsLoading(false);
      });
  };
  const xAxisData = data.xAxis[0].data;
  
  // Format the xAxis labels
  const formattedXAxis = formatXAxisLabels(xAxisData);
  console.log(formattedXAxis);

  data.xAxis[0].data = formattedXAxis;

  useEffect(() => {
    // Fetch data initially
    fetchData();

    // Connect to the Socket.IO server
    const socket = io(port); // Replace with the correct port if needed

    // Listen for the "new-registration" event
    socket.on("new-registration", () => {
      console.log("New registration detected");
      fetchData(); // Re-fetch data on new registration
    });

    // Cleanup the socket connection on unmount
    return () => {
      socket.off("new-registration"); // Remove the event listener
      socket.disconnect(); // Disconnect the socket
    };
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center",alignItems:"center", flexDirection: "column" }}>
      <h4
        className="chart-title"
        style={{ marginBottom: 20, alignSelf: "center", marginTop: 20 }}
      >
        Venue-Wise Count
      </h4>
      {isLoading ? (
        <p style={{ textAlign: "center" }}>Loading chart data...</p>
      ) : (
        <div className="responsiveBarChart2">
            <BarChart
              xAxis={data.xAxis}
              series={data.series}
              barCategoryGap={20}
              barGap={5}
              animationEasing="ease-out"
              animationDuration={800}
            />
          </div>

      )}
    </div>
  );
}

export default VenueWiseCounts;
